import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CouponViewModel } from '../../../domains/payment/models/payment.model';

@Component({
  selector: 'gdp-discount-item',
  templateUrl: './discount-item.component.html',
  styleUrls: ['./discount-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiscountItemComponent implements OnInit {
  @Input() coupon: CouponViewModel;
  @Input() locale: string;
  @Input() currency: string;
  @Input() canRemove: boolean = true;
  @Output() onRemoveCoupon: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void { }

}